import React, { memo, useState } from 'react'
import VerificationSuccess from './verification-success'
import VerificationError from './verification-error'
import TokenExpired from './token-expired'
import VerificationClosed from './verification-closed'
import EmailVerification from './EmailVerification'

const VerificationHome = memo(() => {
  const [currentState, setCurrentState] = useState('VERIFY')
  const [requestId, setRequestId] = useState('')

  const updateState = (resFlag, data) => {
    const { status = '', id = '', email_confirmed = false } = data
    if (resFlag) {
      if (!email_confirmed) {
        setCurrentState('EXPIRED')
      } else if (status === 'CLOSED') {
        setCurrentState('CLOSED')
      } else if (status !== 'CLOSED') {
        setCurrentState('SUCCESS')
      } else {
        setCurrentState('ERROR')
      }
      setRequestId(id)
    } else {
      setCurrentState('ERROR')
    }
  }

  const showState = (state) => {
    const VERIFICATION_STATES = {
      EXPIRED: <TokenExpired reqid={requestId} />,
      ERROR: <VerificationError reqid={requestId} />,
      SUCCESS: <VerificationSuccess reqid={requestId} />,
      CLOSED: <VerificationClosed reqid={requestId} />,
      VERIFY: <EmailVerification changeState={updateState} />,
    }
    return VERIFICATION_STATES[state]
  }
  return <>{showState(currentState)}</>
})

VerificationHome.displayName = 'VerificationHome'
export default VerificationHome
